import React from 'react'
import { Dialog, DialogTitle, DialogContent, Box, Typography, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

const ProfileModal = ({ open, onClose, participant }) => {
  if (!participant) return null

  const imageUrl = participant.photo || participant.referenceImage
  const confidence = participant.faceMatchConfidence || '98.7'

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 1,
          maxHeight: { xs: '90vh', sm: '85vh', md: '80vh' },
        },
      }}>
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: { xs: 1.5, sm: 2, md: 2.5 },
          borderBottom: (theme) =>
            `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.12)'}`,
        }}>
        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 600,
            color: 'text.primary',
            fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' },
          }}>
          Image
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: 'text.secondary',
            '&:hover': {
              color: 'text.primary',
              backgroundColor: (theme) =>
                theme.palette.mode === 'light'
                  ? 'rgba(0, 0, 0, 0.04)'
                  : 'rgba(255, 255, 255, 0.08)',
            },
          }}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content */}
      <DialogContent
        sx={{
          p: { xs: 2, sm: 2.5, md: 3 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 2, sm: 2.5, md: 3 },
          '&.MuiDialogContent-root': {
            paddingTop: { xs: 2, sm: 2.5, md: 3 },
          },
        }}>
        {/* Profile Image */}
        <Box
          sx={{
            width: { xs: '100%', sm: '80%', md: '70%' },
            maxWidth: { xs: 300, sm: 400, md: 500 },
            aspectRatio: '1/1',
            borderRadius: 1,
            overflow: 'hidden',
            backgroundColor: (theme) =>
              theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(30, 30, 30, 1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: (theme) =>
              `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'}`,
            boxShadow: (theme) =>
              theme.palette.mode === 'light'
                ? '0 2px 8px rgba(0, 0, 0, 0.1)'
                : '0 2px 8px rgba(0, 0, 0, 0.3)',
          }}>
          {imageUrl ? (
            <Box
              component="img"
              src={imageUrl}
              alt="Profile"
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <PersonOutlineIcon
              sx={{
                fontSize: { xs: '4rem', sm: '5rem', md: '6rem' },
                color: 'text.disabled',
              }}
            />
          )}
        </Box>

        {/* Face Match Confidence Bar */}
        <Box
          sx={{
            width: '100%',
            p: { xs: 1.25, sm: 1.5, md: 1.75 },
            borderRadius: 1,
            backgroundColor: (theme) =>
              theme.palette.mode === 'light' ? 'rgba(76, 175, 80, 0.1)' : 'rgba(76, 175, 80, 0.2)',
            textAlign: 'center',
            border: (theme) =>
              `1px solid ${theme.palette.mode === 'light' ? 'rgba(76, 175, 80, 0.2)' : 'rgba(76, 175, 80, 0.3)'}`,
          }}>
          <Typography
            sx={{
              fontWeight: 600,
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? 'rgba(76, 175, 80, 0.9)'
                  : 'rgba(129, 199, 132, 0.9)',
              fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
            }}>
            Face Match Confidence: {confidence}%
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default ProfileModal
